var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { takeEvery, takeLatest } from 'redux-saga/effects';
import * as actions from '../constants/actionTypes';
import callApi from '../graphql/callApi';
import sagaFactory from '../utils/sagaFactory';
export var getHubs = sagaFactory('getHubs', actions.getHubs, callApi.getHubs, 'hubs');
export var toggleZipCode = sagaFactory('toggleZipCode', actions.toggleZipCode, callApi.toggleZipCode, 'toggleZipCode');
export var includeZipCodes = sagaFactory('includeZipCodes', actions.includeZipCodes, callApi.includeZipCodes, 'includeZipCodes');
export var createZone = sagaFactory('createZone', actions.createZone, callApi.createZone, 'createZone');
export var updateZone = sagaFactory('updateZone', actions.updateZone, callApi.updateZone, 'updateZone');
export var deleteZone = sagaFactory('deleteZone', actions.deleteZone, callApi.deleteZone, 'deleteZone');
export var batchUpdateServicedZipCodes = sagaFactory('batchUpdateServicedZipCodes', actions.batchUpdateServicedZipCodes, callApi.batchUpdateServicedZipCodes, 'batchUpdateServicedZipCodes');
function hubsSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actions.getHubs.type.REQUEST, getHubs)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.toggleZipCode.type.REQUEST, toggleZipCode)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.includeZipCodes.type.REQUEST, includeZipCodes)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createZone.type.REQUEST, createZone)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.updateZone.type.REQUEST, updateZone)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.deleteZone.type.REQUEST, deleteZone)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.batchUpdateServicedZipCodes.type.REQUEST, batchUpdateServicedZipCodes)];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default hubsSaga;
//# sourceMappingURL=hubs.js.map